import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class CampaignRunViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.CAMPAIGN_RUN_VIEW = '/api/campaign-run-view';
        this.TEMPLATE_USE_COUNT_BY_PROJECT_ID = '/count/template/{projectId}';
        this.GET_LIST_FILTERED = '/list/filtered';
    }

    async getTemplateUseCountByProjectId(projectId) {
        try {
            let url = window.location.origin + this.CAMPAIGN_RUN_VIEW + this.TEMPLATE_USE_COUNT_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId);
            const templateUseCount = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return templateUseCount;
        } catch(err) {
            console.log(err);
        }
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.CAMPAIGN_RUN_VIEW + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default CampaignRunViewService;
